export const PreloginNavigationMixin = {
  methods: {
    tryResuming(router: any, redirect = '') {
      const TRY_RESUMING = localStorage.getItem('auth:tryResuming');

      if (TRY_RESUMING) {
        let link = '/loading?referrer=login';

        if (redirect) {
          link += `&redirect=${redirect}`;
        }

        router.push(link);
      }
    },
  },
};
